import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
  padding: ${props => props.theme.spacing.sp16};
  border-radius: ${props => props.theme.radius.card};
  background-color: ${props => props.theme.colors.background.secondary};
`

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`
